import axios from 'axios';

const prefix = '/packingSlipSharing';

export const savePackingSlipSharingConfiguration = (savePackingSlipSharingRequest) => {
  return axios.put(prefix, savePackingSlipSharingRequest);
};

/**
 * @typedef StoreConfiguration
 * @property {string} storeGuid
 * @property {bool} isPackingSlipSharing - Flag indicating whether packing slip sharing is enabled for store.
 */
/**
 * @typedef GetStoreConfigurationsRequest
 * @property {string[]} storeGuids - List of storeGuids.
 */
/**
 * Request to get packing slip sharing store configurations.
 * @param {GetStoreConfigurationsRequest} request
 * @returns {Promise<AxiosResponse<{storeConfigurations: StoreConfiguration[]}>>}
 */
export const getStoreConfigurations = (request) => {
  return axios.post('/packingSlipSharing/stores', request);
};

/**
 * @typedef PackingSlipInfo
 * @property {string} fulfillmentId
 * @property {string} packingSlipId
 */
/**
 * @typedef GetPackingSlipIdsRequest
 * @property {string[]} fulfillmentIds - List of fulfillmentIds.
 */
/**
 * Request to get packing slip ids assigned to orders on delegation.
 * @param {GetPackingSlipIdsRequest} request
 * @returns {Promise<AxiosResponse<{packingSlipsInfo: PackingSlipInfo[]}>>}
 */
export const getPackingSlipIds = async (request) => {
  return axios.post('/packingslipsharing/packingSlipIds', request);
};
